import { css } from '@epihub/web/src/_ctx/theme';

export const cssCodeInner = css`
  font-family: Menlo, source-code-pro, Monaco, Consolas, 'Courier New', monospace !important;
`;

export const cssCode = css`
  code {
    font-family: Menlo, source-code-pro, Monaco, Consolas, 'Courier New', monospace !important;
  }
`;

export const noScrollbarCSS = `
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    background: transparent !important;
    display: none !important;
    width: 0px  !important;
  }

  /* Hide scrollbar for IE, Edge add Firefox */
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
`;

export const cssNoScrollbar = css(noScrollbarCSS);
